import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { CardBody } from 'reactstrap';

import { createForm } from '../../../../models/Form';
import { createFormField } from '../../../../models/FormField';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import FormFieldType from '../../../../types/FormFieldType';
import CheckoutServiceMethodList from '../../common/CheckoutServiceMethodList';
import CheckoutShippingMethodContent from '../CheckoutShippingMethodContent';

const CheckoutShippingMethod = ({ onOrderUpdate, checkoutStore }) => {
  const { order } = checkoutStore;
  const { selected_shipping, shipping_options } = order;

  const form = useMemo(() => {
    const shippingMethodFormFields = {
      shippingMethodList: createFormField({
        type: FormFieldType.BOOLEAN,
        value: selected_shipping?.module?.id,
        required: true,
      }),
    };

    return createForm(shippingMethodFormFields);
  }, [selected_shipping?.module?.id]);

  const renderContent = (option) => {
    const module = selected_shipping?.module;

    if (module && module.id === option.value) {
      return <CheckoutShippingMethodContent onOrderUpdate={onOrderUpdate} />;
    }

    return null;
  };

  const updateShippingMethod = (option) => {
    order.updateSelectedShipping({ shippingModuleId: option.value });
    onOrderUpdate({ withoutTimer: true });
  };

  return (
    <CardBody
      className={classNames(
        'CheckoutShippingMethod',
        'CheckoutShippingMethod__body'
      )}
    >
      <CheckoutServiceMethodList
        onMethodUpdate={updateShippingMethod}
        form={form}
        fieldName={'shippingMethodList'}
        field={'shippingMethodList'}
        options={shipping_options}
        content={renderContent}
        activeId={selected_shipping?.module ? selected_shipping.module.id : 0}
        useMobileStackedLayout={true}
        methodImageVariant="checkout-method-list"
      />
    </CardBody>
  );
};

CheckoutShippingMethod.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
};

export default inject('checkoutStore')(observer(CheckoutShippingMethod));
